import EL from '../../../EL/EL.js';
import HR from '../../../DOM/hr/HR.js';
import { HTMLELEMENT } from '../../../../enums/HTMLELEMENT.js';
import P from '../../../DOM/p/P.js';
import SPAN from '../../../DOM/span/SPAN.js';
import UL from '../../../DOM/LIST/ul/UL.js';
import OL from '../../../DOM/LIST/ol/OL.js';
import HEADING from '../../../DOM/heading/HEADING.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import Translatable from '../../../../interface/Translatable.js';
// Model Structure
export const textBlockAttr = makeAttrStruct([
    ['class', ''],
    ['name', '']
]);
export const textBlockData = makeDataStruct([
    ['text', ''],
    ['textGroup', ''],
    ['textKey', '']
]);
export const textBlockModel = makeStruct([
    ['attributes', textBlockAttr],
    ['data', textBlockData]
]);
// Simplified model
export function textBlock(className, name) {
    return {
        attributes: textBlockAttr(className, name),
        data: textBlockData()
    };
}
/** A generic element that contains Text */
export default class TEXTBLOCK extends EL {
    constructor(node, model) {
        super(node, HTMLELEMENT.DIV, model);
        this.addClass('textblock');
        this.implement(new Translatable(this));
        this.setInnerHTML(model.data.text || '');
    }
    addHeading(model) {
        return this.addChild(new HEADING(this, model));
    }
    addHR(model) {
        return this.addChild(new HR(this, model));
    }
    addParagraph(model) {
        return this.addChild(new P(this, model));
    }
    addSpan(model) {
        return this.addChild(new SPAN(this, model));
    }
    addUL(model) {
        return this.addChild(new UL(this, model));
    }
    addOL(model) {
        return this.addChild(new OL(this, model));
    }
}
